import React, {useState, useEffect} from "react";
import {
    Typography,
    Card,
    CardHeader,
    CardBody,
    IconButton,
    Menu,
    MenuHandler,
    MenuList,
    MenuItem,
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,
    Checkbox, Button,
} from "@material-tailwind/react";
import {PencilIcon} from "@heroicons/react/24/solid";

const Discounts = ({routes, username, role}) => {
    const [discounts, setDiscounts] = useState([]);
    const [unofficialDiscounts, setUnofficialDiscounts] = useState([]);
    const [discountType, setDiscountType] = useState('normal'); /* normal - special - unofficial */

    useEffect(() => {
        fetch("/discounts.json")
            .then((response) => response.json())
            .then((data) => setDiscounts(data))
            .catch((error) => console.error("Error fetching discounts:", error));

        fetchUnofficialDiscounts();
    }, []);

    const toggleDiscounts = async (type) => {
        await loadDiscounts(type);
        setDiscountType(type);
    }

    const loadDiscounts = async (type) => {
        let url = `/discounts.json`;

        if (type === 'special') {
            url = `/discounts/special_discounts.json`;
        }

        try {
            const response = await fetch(url);
            const data = await response.json();
            setDiscounts(data);
        } catch (err) {
            console.error("Error fetching discounts:", err);
        }
    };

    const fetchUnofficialDiscounts = async () => {
        try {
            const response = await fetch("/unofficial_discounts.json");
            const data = await response.json();
            setUnofficialDiscounts(data);
        } catch (error) {
            console.error("Error fetching unofficial discounts:", error);
        }
    };

    const discountTabs = [
        {
            label: "Descuentos",
            value: "normal",
        },
        {
            label: "Descuentos especiales",
            value: "special",
        },
        {
            label: "Descuentos extraoficiales",
            value: "unofficial",
        },
    ];

    return (
        <>
            <div className="mt-12">
                <div className="mb-4 grid grid-cols-1 gap-6 xl:grid-cols-1">
                    <Card className="overflow-hidden xl:col-span-2 border border-blue-gray-100 shadow-sm">
                        <CardHeader
                            floated={false}
                            shadow={false}
                            color="transparent"
                            className="m-0 p-6 w-full"
                        >
                            <div className="flex flex-col gap-4 mb-4 w-full md:flex-row md:items-center md:justify-between">
                                <Typography variant="h6" color="blue-gray" className="mb-1">
                                    Descuentos
                                </Typography>

                                <div className="flex flex-col gap-2 w-full md:w-auto md:flex-row">
                                    {(role === 'admin' || role === 'god') && (
                                        <a href='/discounts/register_discount' className="flex w-full md:w-auto">
                                            <Button
                                                variant={"gradient"}
                                                color={"blue"}
                                                className="flex items-center justify-center gap-2 px-4 capitalize w-full md:w-auto"
                                                size="sm"
                                            >
                                                <Typography color="inherit" className="font-medium capitalize">
                                                    Alta descuento especial
                                                </Typography>
                                            </Button>
                                        </a>
                                    )}

                                    <a href='/discounts/register_unofficial_discount' className="flex w-full md:w-auto">
                                        <Button
                                            variant={"gradient"}
                                            color={"blue"}
                                            className="flex items-center justify-center gap-2 px-4 capitalize w-full md:w-auto"
                                            size="sm"
                                        >
                                            <Typography color="inherit" className="font-medium capitalize">
                                                Alta descuento extraoficial
                                            </Typography>
                                        </Button>
                                    </a>
                                </div>
                            </div>

                        </CardHeader>
                        <CardBody className="px-2 pt-0 pb-2">
                            <Tabs value={discountType}>
                                <TabsHeader className="flex-col md:flex-row">
                                    {discountTabs.map(({label, value}) => (
                                        <Tab key={value} value={value}
                                             className="py-2 md:py-1"
                                             onClick={() => toggleDiscounts(value)}>
                                            {label}
                                        </Tab>
                                    ))}
                                </TabsHeader>
                                <TabsBody>
                                    {discountTabs.map(({label, value}) => (
                                        <TabPanel key={value} value={value} className="px-0 overflow-x-auto">
                                            <table className="w-full min-w-[640px] table-auto"
                                                   key={discountType}
                                                   value={discountType}>
                                                <thead>
                                                <tr>
                                                    {discountType === 'unofficial' ? (
                                                        ["Nombre", "Lista de predios", "Nota", "Solicitud", "Administrador", "Tesoreria", "Estatus", "Acciones"].map((el) => (
                                                            <th
                                                                key={el}
                                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                            >
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    {el}
                                                                </Typography>
                                                            </th>
                                                        ))
                                                    ) : (
                                                        ["Nombre", "Porcentaje", "Descripción", "Inicio", "Fin", "Activo", "Acciones"].map((el) => (
                                                            <th
                                                                key={el}
                                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                                            >
                                                                <Typography
                                                                    variant="small"
                                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                                >
                                                                    {el}
                                                                </Typography>
                                                            </th>
                                                        ))
                                                    )}
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {discountType === 'unofficial' ?
                                                    (
                                                        unofficialDiscounts.map((discount, key) => {
                                                            const className = `py-3 px-5 ${key === unofficialDiscounts.length - 1 ? "" : "border-b"}`;

                                                            return (
                                                                <tr key={discount.id}>
                                                                    <td className={className}>

                                                                        <Typography variant="small" color="blue-gray"
                                                                                    className="font-bold">
                                                                            {discount.name}
                                                                        </Typography>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Typography variant="small" color="blue-gray"
                                                                                    className="text-sm">
                                                                            <pre>{discount.parcel_code_list?.join("\n")}</pre>
                                                                        </Typography>
                                                                    </td>
                                                                    <td className={className}>{discount.note}</td>
                                                                    <td className={className}>{discount.requested_by.username}</td>
                                                                    <td className={className}>
                                                                        {discount.admin_approved ? (
                                                                            <>
                                                                                <Typography variant="small"
                                                                                            color="blue-gray"
                                                                                            className="text-sm">
                                                                                            <span
                                                                                                style={{
                                                                                                    display: 'inline-block',
                                                                                                    width: '10px',
                                                                                                    height: '10px',
                                                                                                    borderRadius: '50%',
                                                                                                    backgroundColor: 'green',
                                                                                                    marginRight: '5px',
                                                                                                }}
                                                                                            ></span>
                                                                                    {discount.admin_approver ? `Aprobado por: ${discount.admin_approver.username}` : 'Aprobado'}
                                                                                </Typography>
                                                                            </>
                                                                        ) : (
                                                                            <>-</>
                                                                        )}
                                                                    </td>
                                                                    <td className={className}>
                                                                        {discount.treasury_approved ? (
                                                                            <>
                                                                                <Typography variant="small"
                                                                                            color="blue-gray"
                                                                                            className="text-sm">
                                                                                                <span
                                                                                                    style={{
                                                                                                        display: 'inline-block',
                                                                                                        width: '10px',
                                                                                                        height: '10px',
                                                                                                        borderRadius: '50%',
                                                                                                        backgroundColor: 'green',
                                                                                                        marginRight: '5px',
                                                                                                    }}
                                                                                                ></span>
                                                                                    {discount.treasury_approver ? `Aprobado por: ${discount.treasury_approver.username}` : 'Aprobado'}
                                                                                </Typography>
                                                                            </>
                                                                        ) : (
                                                                            <>-</>
                                                                        )}
                                                                    </td>

                                                                    <td className={className}>
                                                                        <Typography variant="small" color="blue-gray"
                                                                                    className="text-sm">
                                                                            {discount.admin_approved && discount.treasury_approved ? "Aprobado" : "Pendiente"}
                                                                        </Typography>
                                                                    </td>
                                                                    <td className="px-4 py-2 text-center align-middle">
                                                                        <a href={`/discounts/register_unofficial_discount/${discount.id}`}
                                                                           className="inline-flex p-2 bg-blue-500 text-white justify-center items-center rounded-lg hover:bg-blue-600 transition">
                                                                            <PencilIcon className="w-5 h-5"/>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    ) : (
                                                        discounts.map((discount, key) => {
                                                            const className = `py-3 px-5 ${
                                                                key === discounts.length - 1 ? "" : "border-b border-blue-gray-50"
                                                            }`;

                                                            return (
                                                                <tr key={discount.id}>
                                                                    <td className={className}>
                                                                        <Typography variant="small" color="blue-gray"
                                                                                    className="font-bold">
                                                                            {discount.name}
                                                                        </Typography>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Typography variant="small"
                                                                                    className="text-xs font-medium text-blue-gray-600">
                                                                            {discount.percentage}
                                                                        </Typography>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Typography variant="small"
                                                                                    className="text-xs font-medium text-blue-gray-600">
                                                                            {discount.description}
                                                                        </Typography>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Typography variant="small"
                                                                                    className="text-xs font-medium text-blue-gray-600">
                                                                            {discount.start_date}
                                                                        </Typography>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Typography variant="small"
                                                                                    className="text-xs font-medium text-blue-gray-600">
                                                                            {discount.end_date}
                                                                        </Typography>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Typography variant="small"
                                                                                    className="text-xs font-medium text-blue-gray-600">
                                                                            {discount.active}
                                                                        </Typography>
                                                                        <Checkbox color="blue" checked={discount.active}
                                                                                  disabled={true}/>
                                                                    </td>
                                                                    <td className={className}>
                                                                        <Menu placement="left-start">
                                                                            <MenuHandler>
                                                                                <IconButton size="sm" variant="text"
                                                                                            color="blue-gray">
                                                                                    ...
                                                                                </IconButton>
                                                                            </MenuHandler>
                                                                            <MenuList>
                                                                                {/*<MenuItem*/}
                                                                                {/*    onClick={() => setSelectedRole(lot.id)}>Editar</MenuItem>*/}
                                                                                {/*<MenuItem>Desactivar</MenuItem>*/}
                                                                            </MenuList>
                                                                        </Menu>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })
                                                    )
                                                }
                                                </tbody>
                                            </table>
                                        </TabPanel>
                                    ))}
                                </TabsBody>
                            </Tabs>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </>
    );
};

export default Discounts;